import { ImageColorFinderFlight, VideoColorFinderFlight } from "@nova/protobuf"
import { zoomToShowPoint } from "features/map/control/slice"
import store from "integrations/redux/store"
import { getStartPosition } from "plugins/ColorFinder/V2/ColorFinderQueries"

export function zoomToColorFinder(flight: ImageColorFinderFlight | VideoColorFinderFlight) {
    console.log("zooming to colorfinder")
    const position = getStartPosition(flight)
    console.log(position)
    if (!position) return
    store.dispatch(zoomToShowPoint({ lat: position[1], lng: position[0] }))
}
